import React from 'react';
import { Link } from 'react-router-dom';

const GetStarted = () => {
  return (
    <section id='hero' className='d-flex align-items-center' style={{ backgroundColor: 'white' }}>
      <div className='container'>
        <div className='row'>
          <div
            className='col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1'
            data-aos='fade-up'
            data-aos-delay='200'
          >
            <h1 className='text-dark'>Mine Marketing - Quantum Rules</h1>
            <h2 style={{ color: 'gray' }}>
              This platform will help you find the best marketing strategies for campaign ads.
            </h2>
            <div className='d-flex justify-content-center'>
              <Link className='btn btn-lg btn-outline-dark mr-1' to='/conditions'>
                Conditions
              </Link>
              <Link className='btn btn-lg btn-outline-dark mr-1' to='/Actions'>
                Actions
              </Link>
              <Link className='btn btn-lg btn-outline-dark mr-1' to='/Rules'>
                Rules
              </Link>
              <Link className='btn btn-lg btn-outline-dark mr-1' to='/Logs'>
                Logs
              </Link>
              <Link className='btn btn-lg btn-outline-dark mr-1' to='/generalSettings'>
                Settings
              </Link>
            </div>
          </div>
          <div className='col-lg-6 order-1 order-lg-2 hero-img' data-aos='zoom-in' data-aos-delay='200'>
            <img src='assets/img/hero-img.png' className='img-fluid animated' alt='' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
